import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})
export class SnackbarService {
    constructor(
        private _snackBar: MatSnackBar,
        private translate: TranslateService
    ) {}

    showSuccess(message: string, duration: number = 3000) {
        const config: MatSnackBarConfig = {
            duration: duration,
            panelClass: ['snackbar-success'],
            horizontalPosition: 'end',
            verticalPosition: 'bottom'
        };

        this._snackBar.open(
            this.translate.instant(message),
            'Close',
            config
        );
    }

    showError(message: string, duration: number = 3000) {
        const config: MatSnackBarConfig = {
            duration: duration,
            panelClass: ['snackbar-error'],
            horizontalPosition: 'end',
            verticalPosition: 'bottom'
        };

        this._snackBar.open(
            this.translate.instant(message),
            'Close',
            config
        );
    }
} 